if(!window.$jcallpy) window.$jcallpy = {}

const $ =  window.$jcallpy
//console.log('>>>', $jcallpy)
if(!$jcallpy?.error) {
  //alert('ok')
  $jcallpy.error = function(message)  {
    console.error(message)
  }
}

/**
 * ---------------------------------------->
 * init.js
 * ---------------------------------------->
 */

//(function(){
  window.$jcallpy.callpy_init = function (method) {
    const methods = methods_callpy_init
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method) {
      return methods._init.apply(this, arguments);
    } else {
      //$jcallpy.error('Метод с именем ' + method + ' не существует для ' + global_module_name);
      console.error('Метод с именем ' + method + ' не существует для ' + global_module_name)
    }
  }

  var global_module_name = '$.callpy_init',
  _this = $jcallpy.callpy_init;

  var win = window,
  doc = win.document,
  defaults = {
    callpy_wrapper: '#callpy_wrapper'
  };

  var methods_callpy_init = {
    _init: function() {
      if (!document.querySelector(defaults.callpy_wrapper)) {
        // var callpy_div = $('<div/>', {
        //   id: 'callpy_wrapper',
        //   css: {
        //     display: 'none'
        //   }
        // }).appendTo($('#callpy'));

        const parent = document.querySelector('#callpy')
        const callpy_div = document.createElement('div')
        callpy_div.id = 'callpy_wrapper'
        callpy_div.style.display  = 'none'
        parent.appendChild(callpy_div)


        if (parseInt(m_callpy.client_data.site_info.status) == 0) {
          //callpy_div.addClass('callpy_status_off');
          callpy_div.classList.add('callpy_status_off')
        }
      }
      /* создаем чат */
      //$.callpy_chat('_create'); ===># TO DO #<====
    },
  }
//})()


/**
 * ---------------------------------------->
 * callpy_status
 * ---------------------------------------->
 */
//(function() {
  window.$jcallpy.callpy_status = function (method) {
    const methods = methods_callpy_status
    if (methods[method]) {
        return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method === 'object' || ! method) {
        return methods._init.apply(this, arguments);
    } else {
        $jcallpy.error( 'Метод с именем ' +  method + ' не существует для ' + global_module_name);
    }
  }
  var global_module_name = '$.callpy_status',
  _this = $.callpy_status;

  var win = window,
  doc = win.document,
  defaults = {
    callpy_wrapper: '#callpy_wrapper'
  },
  timer = false

  var methods_callpy_status = {
    _init: function() {

    },
    effect: function() {

    },
    set: function(status, slf) {
        var chat = document.body.querySelector(defaults.callpy_wrapper),
            mobile = $('#callpy_mobile_wrapper'),
            forms = $('.callpy_client_chat_wrapper');
            //s = status;
        if (!status) status = 'default';

        $.callpy_settings('_isActive');
        $.callpy_flat('_check_status_class');

        switch (status) {
            case "default":
                chat.removeClass('callpy_remote_control callpy_remote_control_accept callpy_status_video');
                break;
            case "show_chat":
                if (m_callpy.client_data.site_info.chat_type != "side") {
                    var animEndEventNames = 'webkitAnimationEnd.hideAnimate oAnimationEnd.hideAnimate MSAnimationEnd.hideAnimate animationend.hideAnimate';
                    chat
                        .removeClass('callpy_chat_no_transition')
                        .addClass('callpy_status_chat_show')
                        .removeClass('callpy_status_chat_hide');

                    chat = $('.callpy_chat_wrapper2');
                    chat.removeClass('callpy_hide_chat');
                    chat[0].style.display = 'flex';
                    chat.addClass('callpy_show_chat');

                    chat.on(animEndEventNames, function(event) {
                        chat.removeClass('callpy_show_chat')
                            .off('.hideAnimate');

                        m_callpy.m_storage.saveHtml();
                    });
                }
                else {
                    chat
                        .removeClass('callpy_chat_no_transition')
                        .addClass('callpy_status_chat_show')
                        .removeClass('callpy_status_chat_show--sideLabel')
                        .addClass('callpy_status_chat_hide--sideLabel')
                        .addClass('callpy_status_chat_show--side')//добавил спицифичный класс скрытия для бокового чата.
                        .removeClass('callpy_status_chat_hide--side')//удаление спицифичного класса скрытия для бокового чата.
                        .removeClass('callpy_status_chat_hide');
                }
                break;
            case "hide_chat":
                if (m_callpy.client_data.site_info.chat_type == "flat" || m_callpy.client_data.site_info.chat_type == "brand") {
                    var animEndEventNames2 = 'webkitAnimationEnd.hideAnimate oAnimationEnd.hideAnimate MSAnimationEnd.hideAnimate animationend.hideAnimate';

                    chat = $('.callpy_chat_wrapper2');
                    chat.removeClass('callpy_show_chat');
                    setTimeout(function () {
                        chat.addClass('callpy_hide_chat');
                    }, 25);

                    chat.on(animEndEventNames2, function(event) {
                        chat[0].style.display = 'none';
                        chat.removeClass('callpy_show_chat')
                            .off('.hideAnimate');

                        document.body.querySelector(defaults.callpy_wrapper)
                            .removeClass('callpy_chat_no_transition')
                            .removeClass('callpy_status_chat_show')
                            .addClass('callpy_status_chat_hide');

                        m_callpy.m_storage.saveHtml();
                    });
                }
                else {
                    chat
                        .removeClass('callpy_chat_no_transition')
                        .removeClass('callpy_status_chat_show')
                        .removeClass('callpy_status_chat_hide--sideLabel')
                        .addClass('callpy_status_chat_show--sideLabel')
                        .removeClass('callpy_status_chat_show--side')//удаление спицифичного класса скрытия для бокового чата.
                        .addClass('callpy_status_chat_hide--side')//добавил спицифичный класс скрытия для бокового чата.
                        .addClass('callpy_status_chat_hide');
                }
                break;
            case "incoming_call_on":
                _this('set', 'show_chat');
                chat
                    .addClass('callpy_status_incoming');
                break;
            case "incoming_call_off":
                chat.removeClass('callpy_status_incoming');
                break;
            case "call_on":
                $.callpy_status('set', 'equip_mic_off');
                chat.addClass('callpy_status_call callpy_status_calling');
                timer = setInterval(function() {
                    $.callpy_chat('_setTimer');
                }, 1000);
                break;
            case "call_off":
                chat.removeClass('callpy_status_call callpy_status_calling');

                clearInterval(timer);
                clearInterval($jcallpy.callpy_chat('_setTimer', true));
                break;
            case "dial_on":
                $.callpy_status('set', 'equip_mic_off');
                chat.addClass('callpy_status_call');
                break;
            case "dial_off":
                chat.removeClass('callpy_status_call');
                break;
            case "video_start":
                if (chat.hasClass('callpy_status_calling')) {
                    chat
                        .removeClass('callpy_chat_no_transition')
                        .addClass('callpy_status_video');
                }
                break;
            case "video_end":
                chat
                    .removeClass('callpy_chat_no_transition')
                    .removeClass('callpy_status_video');
                break;
            case "remote_control_on":
                _this('set', 'show_chat');
                chat
                    .removeClass('callpy_chat_no_transition')
                    .addClass('callpy_remote_control');
                break;
            case "remote_control_off":
                chat
                    .removeClass('callpy_chat_no_transition')
                    .removeClass('callpy_remote_control');
                break;
            case "screen_share_on": {
                _this('set', 'show_chat');
                chat
                    .removeClass('callpy_chat_no_transition')
                    .addClass('callpy_screen');
                break;
            }
            case "screen_share_off": {
                _this('set', 'show_chat');
                chat
                    .removeClass('callpy_chat_no_transition')
                    .removeClass('callpy_screen');
                break;
            }
            case "screen_self_share_on": {
                _this('set', 'show_chat');
                chat
                    .removeClass('callpy_chat_no_transition')
                    .addClass('callpy_screen_self');
                break;
            }
            case "screen_self_share_off": {
                chat
                    .removeClass('callpy_chat_no_transition')
                    .removeClass('callpy_screen_self');
                break;
            }
            case "remote_control_start":
                //_this('set', 'show_chat');
                chat
                    .removeClass('callpy_chat_no_transition')
                    .removeClass('callpy_remote_control').addClass('callpy_status_chat_show callpy_remote_control_accept').removeClass('callpy_status_chat_hide');
                break;
            case "remote_control_end":
                chat.removeClass('callpy_remote_control_accept');
                $.callpy_message('_addSys', {type: 'remote_end', text: 'Удаленное управление завершено'});
                break;
            case "audio_on":
                if (parseInt(m_callpy.client_data.site_info.blocked) == 0) {
                    chat.addClass('callpy_status_audio');
                }
                break;
            case "audio_off":
                chat.removeClass('callpy_status_audio');
                break;
            case "avatar_on":
                chat.addClass('callpy_status_icon');
                break;
            case "avatar_off":
                chat.removeClass('callpy_status_icon');
                break;
            case "offline_on":
                //_this('removeStatus');

                chat
                    .removeClass('callpy_status_callback')
                    .removeClass('callpy_status_login');

                $('.callpy_userData_show').removeClass('callpy_userData_show');
                $('.callpy_social_confirm').removeClass('callpy_social_confirm');
                $('.callpy_userdata_active').removeClass('callpy_userdata_active');

                chat
                    .removeClass('callpy_chat_no_transition')
                    .addClass('callpy_status_offline');
                break;
            case "offline_off":
                chat
                    .removeClass('callpy_chat_no_transition')
                    .removeClass('callpy_status_offline')
                    .removeClass('callpy_status_show_offline_chat');
                break;
            case "equip_mic_on":
                chat.addClass('callpy_status_mic_equip');
                break;
            case "equip_mic_off":
                chat.removeClass('callpy_status_mic_equip');
                break;
            case "callpy_off":
                _this('removeStatus');

                chat.addClass('callpy_status_off');
                break;
            case "callpy_on":
                chat.removeClass('callpy_status_off');
                break;
            case "contact_on":
                chat.addClass('callpy_status_contact');
                break;
            case "contact_off":
                chat.removeClass('callpy_status_contact');
                break;
            case "mobile_hide":
                mobile.removeClass('callpy_mobile_visible');
                break;
            case "mobile_show":
                mobile.addClass('callpy_mobile_visible');
                break;
            case "show_form": {
                forms.addClass('callpy_show_forms');

                let chat_input = document.querySelector('.callpy_client_chat_inputs_wr');

                if (chat_input) {
                    chat_input.style.display = 'none';
                }
                break;
            }
            case "hide_form": {
                forms.removeClass('callpy_show_forms');
                let hide_chat_input = document.querySelector('.callpy_client_chat_inputs_wr');

                if (hide_chat_input) {
                    hide_chat_input.style.display = 'flex';
                }
                break;
            }
            case "social_show":
                forms.addClass('callpy_social_confirm');
                break;
            case "social_hide":
                forms.removeClass('callpy_social_confirm');
                break;
            case "social_accept":
                forms
                    .addClass('callpy_social_accept')
                    .removeClass('callpy_social_confirm');
                break;
            case "social_cancel":
                forms
                    .addClass('callpy_social_cancel')
                    .removeClass('callpy_social_confirm');
                break;
            case "userdata_show":
                forms.addClass('callpy_userData_show');
                break;
            case "userdata_hide":
                forms.removeClass('callpy_userData_show');
                break;
            case "departments_show":
                _this('removeStatus');

                chat.addClass('callpy_status_departments_choose');
                chat.removeClass('callpy_status_departments_empty');
                break;
            case "departments_hide":
                chat.removeClass('callpy_status_departments_choose');
                break;
            case "departments_empty_show":
                _this('removeStatus');

                chat.removeClass('callpy_status_departments_choose');
                chat.addClass('callpy_status_departments_empty');
                break;
            case "departments_empty_hide":
                chat.removeClass('callpy_status_departments_empty');
                break;

            case "callback_show":
                _this('removeStatus');

                $('.callpy_client_chat_callback').removeClass('callpy_status_callback_state');
                chat.addClass('callpy_status_callback');
                break;
            case "callback_state_one":
                _this('set', 'callback_show');
                $('.callpy_client_chat_callback').removeClass('callpy_status_callback_state');
                break;
            case "callback_state_two":
                _this('set', 'callback_show');
                $('.callpy_client_chat_callback').addClass('callpy_status_callback_state');
                break;
            case "callback_hide":
                chat.removeClass('callpy_status_callback');
                $('.callpy_client_chat_callback').removeClass('callpy_status_callback_state');
                break;
            case "login_show":
                _this('removeStatus');
                chat.addClass('callpy_status_login');
                break;
            case "login_hide":
                chat.removeClass('callpy_status_login');
                break;
            case "login_active":
                chat.addClass('callpy_close_area_accept');
                break;
            case "login_active_off":
                chat.removeClass('callpy_close_area_accept');
                break;
            case "label_hidden_on":
                chat.addClass('callpy_status_label_off');
                break;
            case "label_hidden_off":
                chat.removeClass('callpy_status_label_off');
                break;
            case "dialog_toggle":
                if (chat.hasClass('callpy_status_dialog')) {
                    _this('set', 'dialog_hide');
                }
                else {
                    _this('set', 'dialog_show');
                }
                break;
            case "dialog_show":
                _this('removeStatus');

                chat.addClass('callpy_status_dialog');
                break;
            case "dialog_hide":
                chat.removeClass('callpy_status_dialog');
                break;


            case "buttons_on":
                chat.addClass('callpy_status_buttons');
                break;
            case "buttons_off":
                chat.removeClass('callpy_status_buttons');
                var inputs_block = document.querySelector('.callpy_client_chat_inputs__block');
                inputs_block.dataset.formId = '';
                inputs_block.dataset.formType = '';
                break;

        }

        if (slf) {
            m_callpy.m_storage.saveHtml(true);
        }
        else {
            m_callpy.m_storage.saveHtml();
        }

    },
    api: function() {
        return {
          visible: false,
          offline:false,
          call: false,
          video: false,
          remote: false,
          mobile: false
        }
        // var callpy = document.body.querySelector(defaults.callpy_wrapper)//$(defaults.callpy_wrapper);
        // console.log('callpy', callpy, defaults)
        // if(!callpy) return

        //TO DO: 
        return {
            visible: callpy.hasClass('callpy_status_chat_show') ? true : false,
            offline: (callpy.hasClass('callpy_status_offline') || m_callpy.client_data.peer_key == 0) ? true : false,
            call: callpy.hasClass('callpy_status_calling') ? true : false,
            video: callpy.hasClass('callpy_status_video') ? true : false,
            remote: callpy.hasClass('callpy_remote_control_accept') ? true : false,
            mobile: callpy.hasClass('callpy_status_mobile') ? true : false
        }
    },
    removeStatus: function(slf) {
        var chat = document.body.querySelector(defaults.callpy_wrapper);
        if(!chat) return

        //TO DO
        chat
            .removeClass('callpy_status_departments_choose')
            .removeClass('callpy_status_callback')
            .removeClass('callpy_status_departments_empty')
            .removeClass('callpy_status_dialog')
            .removeClass('callpy_status_login')
            .removeClass('callpy_screen')
            .removeClass('callpy_screen_self');

        $('.callpy_userData_show').removeClass('callpy_userData_show');
        $('.callpy_social_confirm').removeClass('callpy_social_confirm');
        $('.callpy_userdata_active').removeClass('callpy_userdata_active');

        if (slf) {
            m_callpy.m_storage.saveHtml(true);
        }
    }
    //**/
  }

//})()

/**
 * ---------------------------------------->
 * 
 * ---------------------------------------->
 */
$.callpy_departments = function(method) {
    const methods = methods_callpy_departments
  if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
  } else if (typeof method === 'object' || ! method) {
      return methods._init.apply(this, arguments);
  } else {
      $jcallpy.error( 'Метод с именем ' +  method + ' не существует для ' + global_module_name);
  }
};
var global_module_name = '$.callpy_departments',
  _this = $.callpy_departments;

var methods_callpy_departments = {
  _init: function () {
      _this('_create_select');
  },
  _events: function () {
      /*var selects = document.querySelectorAll('.callpy_departaments_select');
      if (selects.length > 0) {
          $(selects).each(function () {
              var t = this,
                  $this = $(t);
              $this.on('change', function () {
                  _this('_change_department', t.value);
              });
          });
      }*/
      if (document.getElementById("callpy_form_box") && document.getElementById("callpy_form_box").querySelector("form")){
          document.getElementById("callpy_form_box").querySelector("form").addEventListener('submit', function(e){
              e.preventDefault();
              var form_id = document.getElementById("callpy_form_box").querySelector("form").dataset.id;
              var formData = {};
              document.getElementById("callpy_form_box").querySelector("form").querySelectorAll("input").forEach(function(i){
                  formData[i.name] = i.value;
              })
              var data = {
                  action: 'addFormData',
                  site_id: m_callpy.client_data.site_id,
                  site: m_callpy.client_data.site,
                  key: m_callpy.client_data.key,
                  channel: m_callpy.client_data.channel,
                  formType: "siteForm",
                  form_id: form_id,
                  data: formData
              };

              m_callpy.m_user.formData({
                  formType: "siteForm",
                  form_id: form_id,
                  data: formData
              });

              var form = m_callpy.client_data.site_info.forms[form_id];
              var ad = null;
              var form_html = document.querySelector('#callpy_form_box');

              if (form.additional_data) {
                  ad = JSON.parse(form.additional_data);
              }


              $.post(callpy_path + 'd/', data, function () {
                  if (ad && ad.text_filled) {
                      document.querySelector('.callpy_forms_title').innerHTML = ad.text_filled;

                      form_html.innerHTML = '\
                                  <div class="callpy_forms_departments_buttons">\
                                      <button class="callpy_flat_button">' + _("Ок") + '</button>\
                                  </div>';

                      form_html.querySelector('.callpy_flat_button').addEventListener('click', function(evt) {
                          evt.preventDefault();
                          $.callpy_status('set', 'hide_form', true);
                          return false;
                      });
                  }
                  else {
                      $.callpy_status('set', 'hide_form');
                  }
                  m_callpy.m_storage.saveHtml(true);
                  m_callpy.m_autos.checkAllConditions({form_id: form_id});
              });

              return false;

          });
      }

      // ENvoie de message pour les formulaire de type: departement
    //   $('#callpy_departments_form').on('submit', function() {
    //       var $this = $(this);
    //       var fields = {};

    //       $this.find('input').each(function(i, t) {
    //           fields[$(t).data('callpy-departments-input-id')] = $(t).val();
    //       });

    //       $.post(callpy_global.php_server + '/d/', {
    //           action: "addFormData",
    //           site_id: m_callpy.client_data.site_id,
    //           key: m_callpy.client_data.key,
    //           channel: m_callpy.client_data.channel,
    //           site: m_callpy.client_data.site,
    //           formType: "departmentForm",
    //           data: fields
    //       }, function() {
    //           m_callpy.m_user.formData({
    //               formType: "departmentForm",
    //               data: fields
    //           });

    //           $('.callpy_client_chat_wrapper').removeClass('callpy_departmentsForm_show');
    //           m_callpy.m_storage.saveHtml(true);
    //       });

    //       return false;
    //   });
      // Traitement des cations liées aux consultants
    //   $('#callpy_cancel_departments').on('click', function() {
    //       $('.callpy_client_chat_wrapper').removeClass('callpy_departmentsForm_show');
    //       m_callpy.m_storage.saveHtml(true);
    //   });

    //   $('.callpy_departments_choose_link').on('click', function() {
    //       $.callpy_departments('_change_department', $(this).data('department-id'));

    //       if ($('#callpy_client_chat_departments_ul_li' + $(this).data('department-id')).is(":empty")) {
    //           $.callpy_status('set', 'departments_empty_show', true);
    //       }

    //       $.callpy_status('set', 'departments_hide', true);
    //   });

      document.querySelectorAll('.callpy_form_action_buttons').forEach(function (item) {
          item.addEventListener('click', function () {
              let div_wrapper = document.querySelector('.callpy_client_chat_inputs__block');
              let action = item.dataset.form ? JSON.parse(decodeURIComponent(item.dataset.form)) : null;
              if (action) {
                  m_callpy.m_autos.checkAllConditions(action);
              }
              $.callpy_status('set', 'buttons_off', true);
              div_wrapper.innerHTML = '';
          });
      });
  },
  _isForm: function() {
      if (m_callpy.client_data.type == 5) {
          return false;
      }

      var departments = m_callpy.client_data.site_info.departments,
          result;
      if (!m_callpy.client_data.department_id || parseInt(departments[m_callpy.client_data.department_id].form_id) == 0) {
          result = false;
      } else {

          if (!m_callpy.client_data.clientInfo.formData || !m_callpy.client_data.clientInfo.formData.departmentForm || !m_callpy.client_data.clientInfo.formData.departmentForm[m_callpy.client_data.department_id]) {
              result = true;
          }
          else {
              result = false;
          }

      }

      return result;
  },
  _change_department: function(id, withoutSysMessage, callback) {
      //m_callpy.client_data.site_info.departments[14].form_id
      if (id) {
          var departments = m_callpy.client_data.site_info.departments;

          $.post(callpy_global.php_server + '/d/', {
              action: "change_department",
              site_url: m_callpy.client_data.site,
              user: m_callpy.client_data.key,
              department_id: id,
              channel: m_callpy.client_data.channel
          }, function(data) {
              if (!withoutSysMessage) $.callpy_message('_addSys', {type: 'change_department', text: _("Изменен отдел")});
              //UPDATED: если включена настройка разделения сообщений по отделам, необходимо обновить историю переписки
              if (m_callpy.client_data.site_info["s_dividedDepsChats"] == 1){
                  $jcallpy('#callpy_box_for_message').html('');
                  m_callpy.m_chat.set_message_history({history: m_callpy.m_chat.history});
              }

              if (callback) {
                  callback();
              }
          });

          //TODO вообще должно быть в ответе сервера, но есть вопросы к Диме.
          m_callpy.client_data.department_id = id;
          m_callpy.m_storage.saveData();
          m_callpy.m_storage.saveSyncData(true);
          _this('_set_select_department');
      }
  },
  _set_select_department: function() {
      var departments_selects = $('.callpy_departaments_select');
      if (departments_selects.length) {
          departments_selects.val(m_callpy.client_data.department_id);
      }
  },
  _create_form: function () {
      if (parseInt(m_callpy.client_data.site_info.blocked) === 0) {
          //UPDATED: на всякий случай проверка на существование формы
          if (m_callpy.client_data.site_info.departments[m_callpy.client_data.department_id].form_id === 0 || !m_callpy.client_data.site_info.forms[m_callpy.client_data.site_info.departments[m_callpy.client_data.department_id].form_id]) return;

          var form_id = m_callpy.client_data.site_info.departments[m_callpy.client_data.department_id].form_id;
          var inputs = m_callpy.client_data.site_info.forms[form_id].fields,
              inputHtml;

          var form = m_callpy.client_data.site_info.forms[form_id];
          var ad = null;

          if (form.additional_data) {
              ad = JSON.parse(form.additional_data);
          }

          let div_wrapper = document.querySelector('.callpy_client_chat_inputs__block');
          div_wrapper.innerHTML = '';

          let title = document.createElement('div');
          title.className = 'callpy_form_action_buttons__title';
          if (ad.text) {
              title.innerHTML = ad.text;
              document.querySelector('.callpy_forms_title').innerHTML = ad.text;
          }
          else {
              title.innerHTML = form.name;
          }

          div_wrapper.appendChild(title);

          for (var i = 0; i < inputs.length; i++) (function(i){
              if (inputs[i].type === "BUTTON") {
                  let color = '#7EBE72';
                  let css = '';
                  let action = null;
                  if (ad.fields && ad.fields[inputs[i].id]) {
                      if (ad.fields[inputs[i].id]['color']) color = '#' + ad.fields[inputs[i].id]['color'];
                      if (ad.fields[inputs[i].id]['action']) action = '#' + ad.fields[inputs[i].id]['action'];

                      for (let prop in ad.fields[inputs[i].id]) {
                          if (prop !== 'action' && prop.indexOf('hover-') === -1) {
                              let temp = prop;
                              if (prop === 'color') {
                                  temp = 'background-color';
                              }
                              else if (prop === 'font-color') {
                                  temp = 'color';
                              }
                              css += temp + ': ' + ad.fields[inputs[i].id][prop] + ';'
                          }
                      }
                  }

                  let div = document.createElement('div');
                  div.innerHTML = '<a href="javascript://" style="' + css + '" id="callpy_form_action_button_' + inputs[i].id + '" class="callpy_flat_button callpy_form_action_buttons">' + inputs[i].name + '</a>';
                  div_wrapper.appendChild(div);
                  let temp_props = {};
                  let button = div.querySelector('#callpy_form_action_button_' + inputs[i].id);
                  button.onmouseover = function () {
                      let css_arr = ad.fields[inputs[i].id];

                      for (let prop in css_arr) {
                          if (prop.indexOf('hover-') !== -1) {
                              let temp = button.style.getPropertyValue(prop.replace('hover-', ''));
                              if (temp) {
                                  temp_props[prop.replace('hover-', '')] = temp;
                              }
                              button.style.setProperty(prop.replace('hover-', ''), css_arr[prop]);
                          }
                      }
                  };
                  button.onmouseout = function () {
                      let css_arr = ad.fields[inputs[i].id];
                      for (let prop in css_arr) {
                          if (prop.indexOf('hover-') !== -1 && prop !== 'action') {

                              if (temp_props[prop.replace('hover-', '')]) {
                                  button.style.setProperty(prop.replace('hover-', ''), temp_props[prop.replace('hover-', '')]);
                              }
                              else {
                                  button.style.removeProperty(prop.replace('hover-', ''));
                              }
                          }
                      }

                      temp_props = {};
                  };

                  div.querySelector('a').dataset.form = encodeURIComponent(JSON.stringify({form_id: form_id, button_id: inputs[i].id}));
                  div.querySelector('#callpy_form_action_button_' + inputs[i].id).addEventListener('click', function () {
                      //UPDATED: таймер последнего нажатия на кнопку
                      if (m_callpy.m_autos && m_callpy.m_autos.showButtonFormTimer) m_callpy.m_autos.showButtonFormTimer[form_id] = new Date().getTime();
                      //if (action) {
                          m_callpy.m_autos.checkAllConditions({form_id: form_id, button_id: inputs[i].id});
                      //}
                      $.callpy_status('set', 'buttons_off', true);
                      div_wrapper.innerHTML = '';
                  });

              }
          })(i);

          switch (form.form_type) {
              case "BUTTONS": {
                  $.callpy_status('set', 'buttons_on', true);
                  break;
              }
              case "LIKE": {

                  break;
              }
              default: {
                  if (ad && ad.blocked && Boolean(Number(ad.blocked))) {

                      let form_html = document.querySelector('#callpy_form_box');
                      form_html.innerHTML = '';

                      let fieldData = {};

                      let tag_form = document.createElement('form');
                      tag_form.innerHTML = '\
                      <div class="callpy_forms_departments_inputs" id="callpy_departments_form_inputs"></div>\
                      <div class="callpy_forms_departments_buttons">\
                          <button class="callpy_flat_button">' + _("Отправить") + '</button>\
                      </div>';

                      tag_form.dataset.id = form_id;

                      let input_box = tag_form.querySelector('#callpy_departments_form_inputs');

                      for (let i = 0; i < inputs.length; i++) {
                          let filed = document.createElement('div');

                          filed.className = 'callpy_message_form--filed';
                          filed.innerHTML = '<input type="text"' + ( Boolean(Number(inputs[i].required)) ? ' required' : '' ) + ' value="" name="' + inputs[i].id + '" placeholder="' + inputs[i].name + '">';
                          input_box.appendChild(filed);
                          fieldData[inputs[i].id] = {title: inputs[i].name, value: ""};
                      }

                      form_html.appendChild(tag_form);

                      let privacy = document.createElement('div');
                      privacy.classList.add('callpy_forms_user_privacy');
                      privacy.innerHTML = '<input type="checkbox" checked="checked" name="privacy" id="callpy_form_privacy" required>\
                          \
                          <label class="" for="callpy_form_privacy">' + _("Согласие на обработку персональных данных") + '</label>\
                      ';

                      tag_form.appendChild(privacy);
                      tag_form.addEventListener('submit', function(ev) {
                          ev.preventDefault();
                          let data = {
                              action: 'addFormData',
                              site_id: m_callpy.client_data.site_id,
                              site: m_callpy.client_data.site,
                              key: m_callpy.client_data.key,
                              channel: m_callpy.client_data.channel,
                              formType: "siteForm",
                              form_id: form_id,
                              data: {}
                          };

                          let inputs = $(tag_form).serializeArray();

                          for (let i = 0; i < inputs.length; i++) {
                              data.data[inputs[i].name] = inputs[i].value;
                              //fieldData['field_id' + inputs[i].name] = inputs[i].value;
                              fieldData[inputs[i].name] ? fieldData[inputs[i].name]["value"] = inputs[i].value : false ;
                          }

                          m_callpy.m_user.formData({
                              formType: "siteForm",
                              form_id: form_id,
                              data: fieldData
                          });


                          $.post(callpy_path + 'd/', data, function () {
                              if (ad && ad.text_filled) {
                                  document.querySelector('.callpy_forms_title').innerHTML = ad.text_filled;

                                  form_html.innerHTML = '\
                                  <div class="callpy_forms_departments_buttons">\
                                      <button class="callpy_flat_button">' + _("Ок") + '</button>\
                                  </div>';

                                  form_html.querySelector('.callpy_flat_button').addEventListener('click', function(evt) {
                                      evt.preventDefault();
                                      $.callpy_status('set', 'hide_form', true);
                                      return false;
                                  });
                              }
                              else {
                                  $.callpy_status('set', 'hide_form');
                              }
                              m_callpy.m_storage.saveHtml(true);
                              m_callpy.m_autos.checkAllConditions({form_id: form_id});
                          });

                          return false;
                      });

                      $.callpy_status('set', 'show_form', true);
                  }
                  else {
                      $.callpy_message('_createForm', form_id);
                  }
                  break
              }
          }

          m_callpy.m_storage.saveHtml(true);
      }
  },
  _create_select: function() {
      /*var selects = document.querySelectorAll('.callpy_departaments_select'),
          departments = m_callpy.client_data.site_info.departments;
      var count = 0;

      $(selects).html('');

      if (selects.length > 0) {
          for (var i = 0; i <= Object.keys(departments).length - 1; i++) {
              if (parseInt(m_callpy.client_data.site_info.blocked) == 0) {
                  count++;

                  var opt = document.createElement('option');
                  opt.value = Object.keys(departments)[i];
                  opt.innerHTML = departments[Object.keys(departments)[i]].name;

                  if (parseInt(departments[Object.keys(departments)[i]].hidden) == 1) {
                      opt.disabled = true;
                  }

                  $(selects).append(opt);
              }
          }

          if (count <= 1) {
              $(selects).each(function () {
                  var t = $(this);
                  t.parent().hide();
              });
          }
          else {
              $(selects).each(function () {
                  var t = $(this);
                  t.parent().show();
              });
          }

          $.callpy_flat('_setSize');
          $.callpy_chat('_offline_resize');
      }*/

     //============> ЗАПОЛНЕНИЕ СПИСКОВ ОДЕЛА
    //   var departments = m_callpy.client_data.site_info.departments;
    //   var departments_box = document.getElementById('callpy_client_chat_departments_ul')//$('#callpy_client_chat_departments_ul');
    //   departments_box.innerHTML = '' //departments_box.empty();

    //   for (var key in departments) {
    //       if (departments[key].hidden == 0) {
    //         //const elem = document.createElement('li')
    //           $('<li/>', {
    //               html: '\
    //               <div class="callpy_department_title">' + departments[key].name + '</div>\
    //               <div class="callpy_department_managers_list">\
    //                   <ul id="callpy_client_chat_departments_ul_li' + key + '" class="callpy_department_managers_list_ul"></ul>\
    //                   <div class="callpy_department_managers_list_empty">' + _("Нет консультантов") + '</div>\
    //               </div>\
    //               <div class="callpy_department_button">\
    //                   <a href="javascript://" class="callpy_departments_choose_link" data-department-id="' + key + '">' + _("Выбрать") + '</a>' +
    //               '</div>'
    //           }).appendTo(departments_box);
    //       }
    //   }
    

    //   if (m_callpy.client_data.type != 5) {
    //       var ml = m_callpy.managers_list;
    //       for (var jey in ml) {
    //           if (!ml[jey]) continue;
    //           for (var i = 0; i < ml[jey].departments.length; i++) {
    //               $('#callpy_client_chat_departments_ul_li' + ml[jey].departments[i]).append($('<li/>', {html: '<img alt="' + ml[jey].name + '" src="' + callpy_path + 'images/avatar/' + ml[jey].avatar + '.jpg">'}));
    //           }
    //       }
    //   }
    //===================> END
  },
  select: function() {}
}


